import { apiFetchJson } from "@/utils/apiFetch";

const BASE_API_URL = import.meta.env.VITE_API_URL;

export const analyticsService = {
  sentUserEvents: async (payload: unknown): Promise<unknown> => {
    return apiFetchJson<unknown>(`${BASE_API_URL}/usage/events/`, {
      method: "POST",
      body: JSON.stringify(payload),
    });
  },
};
